/* SHOP 商品一覧: サーバー描画済みカードを GENDER/TYPE/SORT/検索 で絞り込み（本番 shop.html の挙動を移植） */
(function () {
  var grid = document.getElementById('js-grid');
  if (!grid) return;

  var items = Array.prototype.slice.call(grid.querySelectorAll('.item'));
  var genderLinks = Array.prototype.slice.call(document.querySelectorAll('.s-pill_filter ul a'));
  var catLinks = Array.prototype.slice.call(document.querySelectorAll('.s-tab_filter ul a'));
  var sortSelect = document.getElementById('js-sort');
  var countEl = document.querySelector('.s-filter_bar .count');
  var headingEl = document.querySelector('.cat_heading');

  // 表示文言は Liquid から（locales dw.shop.*）。翻訳できるようにするため JS には直書きしない。
  // 読み込み順に左右されないよう、使うときに参照する。
  var L = function () { return window.DW_SHOP_LABELS || {}; };
  var t = function (tpl, token, value) {
    return (tpl || '').split(token).join(value);
  };

  var state = { g: 'all', cat: 'all', sort: 'new', q: '' };
  var GENDER_LABEL = { all: 'ALL', ladies: 'LADIES', mens: 'MENS', unisex: 'UNISEX' };
  var CAT_LABEL = { all: 'ALL', pants: 'PANTS', skirt: 'SKIRT', outer: 'OUTER', shirts: 'SHIRTS', cut: 'CUT & SEWN', others: 'OTHERS' };

  var params = new URLSearchParams(location.search);
  if (params.get('g')) state.g = params.get('g');
  if (params.get('cat')) state.cat = params.get('cat');
  if (params.get('q')) state.q = params.get('q');
  if (state.q) {
    var searchInput = document.querySelector('#search-modal input[name="q"]');
    if (searchInput) searchInput.value = state.q;
  }

  var emptyMsg = grid.querySelector('.s-empty');
  if (!emptyMsg) {
    emptyMsg = document.createElement('p');
    emptyMsg.className = 's-empty';
    emptyMsg.textContent = L().empty || '該当する商品がありません。';
    emptyMsg.style.cssText = 'grid-column:1/-1;text-align:center;padding:60px 0;color:#888;display:none;';
    grid.appendChild(emptyMsg);
  }

  function paramKey(href) {
    var m = (href || '').match(/[?&](g|cat)=([^&]+)/);
    return m ? { key: m[1], val: m[2] } : null;
  }
  function setActive(links, attrKey) {
    links.forEach(function (a) {
      var p = paramKey(a.getAttribute('href'));
      a.classList.toggle('is-current', !!p && p.val === state[attrKey]);
    });
  }
  function apply() {
    var q = (state.q || '').trim().toLowerCase();
    var visible = items.filter(function (el) {
      var okG = state.g === 'all' || el.getAttribute('data-gender') === state.g;
      var okC = state.cat === 'all' || el.getAttribute('data-category') === state.cat;
      var okQ = !q || (el.getAttribute('data-search') || '').indexOf(q) >= 0;
      return okG && okC && okQ;
    });
    if (state.sort === 'price_asc' || state.sort === 'price_desc') {
      visible.sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-price'), 10);
        var pb = parseInt(b.getAttribute('data-price'), 10);
        return state.sort === 'price_asc' ? pa - pb : pb - pa;
      });
    } else {
      visible.sort(function (a, b) { return items.indexOf(a) - items.indexOf(b); });
    }
    items.forEach(function (el) { el.style.display = 'none'; });
    visible.forEach(function (el) { el.style.display = ''; grid.insertBefore(el, emptyMsg); });
    emptyMsg.style.display = visible.length ? 'none' : '';
    if (countEl) countEl.textContent = t(L().count || '全 __N__ 件', '__N__', visible.length);
    if (headingEl) {
      headingEl.textContent = q ? t(L().searchResult || '「__Q__」の検索結果', '__Q__', state.q.trim())
        : state.cat !== 'all' ? CAT_LABEL[state.cat]
          : state.g !== 'all' ? GENDER_LABEL[state.g] : 'ALL';
    }
    setActive(genderLinks, 'g');
    setActive(catLinks, 'cat');
  }
  genderLinks.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var p = paramKey(a.getAttribute('href')); if (!p) return;
      e.preventDefault(); state.g = p.val; apply();
    });
  });
  catLinks.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var p = paramKey(a.getAttribute('href')); if (!p) return;
      e.preventDefault(); state.cat = p.val; apply();
    });
  });
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      state.sort = sortSelect.value || 'new';
      apply();
    });
  }
  apply();
})();
